import DragDropFiles from '@/components/Record/DragDropFiles';
import UploadList from '@/components/Record/UploadList';

const RecordUpload = () => {
  return (
    <DragDropFiles>
      <UploadList />
    </DragDropFiles>
  );
};

export default RecordUpload;
